// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "robinhoodEngAnimals-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "robinhoodEngComments-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "robinhoodEngLikes-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "robinhoodEngPosts-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "robinhoodEngSubscriptions-master",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "robinhoodenge4e445ed49294cb59c51f615a8e56e17-master",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:0b1549ff-5b5b-4e36-b86b-05f9b99196fb",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_pVRb38XXV",
    "aws_user_pools_web_client_id": "52cn2qs84tgk7mjj1hs15qn9uv",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "robinhoodEngPaymentApi",
            "endpoint": "https://yk8gs40i48.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "robinhoodEngGuestApi",
            "endpoint": "https://ctivroeqg8.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "robinhoodEngAdminApi",
            "endpoint": "https://4pyu9ytoy0.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "robinhoodEngUserApi",
            "endpoint": "https://59m4ffm3zg.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "robinhoodEngModeratorApi",
            "endpoint": "https://rxgxs2py88.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_content_delivery_bucket": "robinhoodeng-20190918142610-hostingbucket-master",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d31d267v9grifm.cloudfront.net"
};


export default awsmobile;
